export default __webpack_public_path__ + "static/media/Magnetism_06.45e9cec1.png";